module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_80-9818d7d1d1c21c60176819eeb1695088.png";